import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { toggleClass } from '../../core';
import { getActiveElement } from 'shadow-utils';
import { BaseAdapter } from '../../core/adapters';
import { StepperUtils } from '../core/stepper-utils';
import { STEP_CONSTANTS } from '../step/step-constants';
import { STEPPER_CONSTANTS } from './stepper-constants';
var StepperAdapter = /** @class */ (function (_super) {
    __extends(StepperAdapter, _super);
    function StepperAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(component, STEPPER_CONSTANTS.selectors.STEPPER);
        _this._slotElement = _this._rootElement.querySelector('slot');
        return _this;
    }
    StepperAdapter.prototype.patchSafari = function () {
        this._applyToSteps(function (s) { return s.setAttribute('safari', ''); });
    };
    StepperAdapter.prototype.addSlotChangeListener = function (listener) {
        this._slotElement.addEventListener('slotchange', listener);
    };
    StepperAdapter.prototype.removeSlotChangeListener = function (listener) {
        this._slotElement.addEventListener('slotchange', listener);
    };
    StepperAdapter.prototype.getLastStep = function () {
        var steps = this._getSteps();
        return steps.item(steps.length - 1);
    };
    StepperAdapter.prototype.setSelected = function (step) {
        this._getSteps().forEach(function (s) {
            if (s === step) {
                s.selected = true;
            }
            else {
                s.selected = false;
            }
        });
    };
    StepperAdapter.prototype.assignIndices = function () {
        var steps = this._getSteps();
        steps.forEach(function (tab, index) {
            tab.index = index;
        });
    };
    StepperAdapter.prototype.assignFirstLastStep = function () {
        var steps = this._getSteps();
        if (steps && steps.length > 1) {
            steps[0].setAttribute('first', '');
            steps[steps.length - 1].setAttribute('last', '');
        }
    };
    StepperAdapter.prototype.setLayoutAlign = function (layoutAlign) {
        StepperUtils.setLayoutAlign(this._rootElement, layoutAlign);
    };
    StepperAdapter.prototype.setLayoutMode = function (layoutMode) {
        StepperUtils.setLayoutMode(this._rootElement, layoutMode);
        this._applyToSteps(function (s) { return s.setAttribute(STEP_CONSTANTS.attributes.CLUSTERED, ''); });
    };
    StepperAdapter.prototype.setAlternativeState = function (alternative) {
        StepperUtils.setAlternativeState(this._rootElement, alternative);
        this._applyToSteps(function (step) { return (step.alternative = alternative); });
    };
    StepperAdapter.prototype.setVertical = function (vertical) {
        toggleClass(this._rootElement, vertical, STEPPER_CONSTANTS.classes.VERTICAL);
        this._applyToSteps(function (step) { return (step.vertical = vertical); });
    };
    StepperAdapter.prototype.setLinearState = function (linear) {
        StepperUtils.setLinearState(this._rootElement, linear);
    };
    StepperAdapter.prototype.removeRootListener = function (event, listener) {
        this._rootElement.removeEventListener('click', listener);
    };
    StepperAdapter.prototype.addRootListener = function (event, listener) {
        this._rootElement.addEventListener(event, listener);
    };
    StepperAdapter.prototype.setSelectedByIndex = function (index) {
        this._applyToSteps(function (step) {
            if (step.selected && step.index !== index) {
                step.selected = false;
            }
            if (step.index === index) {
                step.selected = true;
            }
        });
    };
    StepperAdapter.prototype.applyConfiguredSteps = function (steps) {
        var _this = this;
        this._component.querySelectorAll(STEP_CONSTANTS.elementName).forEach(function (n) {
            _this._component.removeChild(n);
        });
        steps.forEach(function (s) { return _this._component.appendChild(s); });
    };
    StepperAdapter.prototype.tryGetFocusedStep = function () {
        var focusedStep = undefined;
        var activeElement = getActiveElement();
        this._applyToSteps(function (step) {
            if (activeElement === getShadowElement(step, STEP_CONSTANTS.selectors.STEP)) {
                focusedStep = step;
            }
        });
        return focusedStep;
    };
    StepperAdapter.prototype.getFocusedOrSelectedStep = function () {
        var focusedStep = this.tryGetFocusedStep();
        if (!focusedStep) {
            focusedStep = this._getSteps()[0];
            focusedStep.focus();
        }
        return focusedStep;
    };
    StepperAdapter.prototype.getStep = function (index) {
        var realIndex = 0;
        var steps = this._getSteps();
        if (index < 0) {
            return steps.item(steps.length - 1);
        }
        if (steps.length > index) {
            realIndex = index;
        }
        return steps.item(realIndex);
    };
    StepperAdapter.prototype.toggleDisabled = function (disabled) {
        this._applyToSteps(function (s) { return s.disabled = disabled; });
    };
    StepperAdapter.prototype.toggleRootClass = function (className, show) {
        toggleClass(this._rootElement, show, className);
    };
    StepperAdapter.prototype.isStepperFocused = function () {
        return this._rootElement.classList.contains(STEPPER_CONSTANTS.classes.FOCUSED);
    };
    StepperAdapter.prototype.setStepsListener = function (event, listener) {
        this._applyToSteps(function (s) { return s.addEventListener(event, listener); });
    };
    StepperAdapter.prototype.removeStepsListener = function (event, listener) {
        this._applyToSteps(function (s) { return s.removeEventListener(event, listener); });
    };
    StepperAdapter.prototype._applyToSteps = function (action) {
        this._getSteps().forEach(action);
    };
    StepperAdapter.prototype._getSteps = function () {
        return this._component.querySelectorAll(STEP_CONSTANTS.elementName);
    };
    return StepperAdapter;
}(BaseAdapter));
export { StepperAdapter };
